"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailCampaignEmailSendRoutingKey = void 0;
var EmailCampaignEmailSendRoutingKey;
(function (EmailCampaignEmailSendRoutingKey) {
    EmailCampaignEmailSendRoutingKey["SendEmailCampaignEmailSend"] = "emailCampaignEmailSend_SendEmailCampaignEmailSend";
})(EmailCampaignEmailSendRoutingKey = exports.EmailCampaignEmailSendRoutingKey || (exports.EmailCampaignEmailSendRoutingKey = {}));
//# sourceMappingURL=types.js.map